import React from 'react';
import FooterBg from 'assets/footer-bg.png';
import { Link } from 'react-router-dom';
import { MapPin } from 'react-feather';

export const Footer = () => {
  return (
    <footer className="bg-black text-gray-300 border-t border-[#F3C72C]/20">
      <div
        className="relative py-16"
        style={{
          backgroundImage: `url('${FooterBg}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.95,
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

        <div className="relative z-10 mx-6 md:mx-32 grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* ABOUT */}
          <div>
            <div className="text-3xl font-extrabold text-[#F3C72C] mb-4">ASHITA</div>
            <p className="text-sm leading-relaxed">
              We build secure, modern, scalable digital tools that empower African businesses,
              farmers, and creators.
            </p>

            <div className="mt-4 flex items-center gap-2 text-sm">
              <MapPin size={18} className="text-[#F3C72C]" />
              Trader Center Ntinda, Kampala Uganda
            </div>
          </div>

          {/* RESOURCES */}
          <div>
            <div className="text-2xl font-bold text-[#F3C72C] mb-4">Resources</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://ashitacreatives.tawk.help/"
                  target="_blank"
                  className="hover:text-[#F3C72C]"
                >
                  Help & Support
                </a>
              </li>
              {/* <li>
                <Link to="/our-products" className="hover:text-[#F3C72C]">
                  Our Products
                </Link>
              </li> */}
              <li>
                <Link to="/privacy-policy" className="hover:text-[#F3C72C]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-[#F3C72C]">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a
                  href="https://ashita.africa/sitemap.xml"
                  target="_blank"
                  className="hover:text-[#F3C72C]"
                >
                  Sitemap
                </a>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <div className="text-2xl font-bold text-[#F3C72C] mb-4">Contact</div>
            <div className="text-sm">
              <div className="mb-3">
                <div className="font-bold">Email</div>
                <a href="mailto:ashitacreatives@gmail.com" className="hover:text-[#F3C72C]">
                  ashitacreatives@gmail.com
                </a>
              </div>

              <div className="mb-3">
                <div className="font-bold">Operations</div>
                +256 773 558 907
              </div>

              <div className="mb-3">
                <div className="font-bold">Development</div>
                +256 782 692 271
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="relative z-10 mt-12 border-t border-[#F3C72C]/20 py-4 text-center text-xs text-gray-400">
          © 2025 Ashita Creatives — Built with precision, designed with purpose.
        </div>
      </div>
    </footer>
  );
};
